const ITEMS = [
  "Real-Time AI Videochat",
  "Photorealistic AI Characters",
  "Conversational AI",
  "Voice Interaction",
  "Emotional Intelligence",
  "Natural Movement",
  "Virtual Companions",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-white/10 py-7">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display px-10 text-sm font-light uppercase tracking-[0.35em] text-white/70">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-cyan-300/60" />
          </div>
        ))}
      </div>
    </div>
  );
}
